<template>
	<v-btn text elevation="0" :ripple="false" v-bind="$attrs" v-on="$listeners">
		<template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
			<slot :name="slot" v-bind="scope" />
		</template>
		<template v-for="(index, name) in $slots" v-slot:[name]>
			<slot :name="name" />
		</template>
	</v-btn>
</template>

<script>
export default {
	name: 'TextButton',
};
</script>

<style scoped lang="scss">
// .v-btn {
// 	&:hover::before {
// 		opacity: 0;
// 	}
// }
</style>
